<div [class.active]="active" class="map-tab__content">
  <ng-content></ng-content>
</div>
